import { asksForNewAttempt, toRefusal } from './refusal';
import type { Refusal, TimedRefusalCode } from './refusal';

export type CodeHoldKind = 'locked' | 'wait';

export interface CodeHold {
  readonly kind: CodeHoldKind;
  readonly reason: TimedRefusalCode;
  readonly seconds: number;
}

export interface CodeEffect {
  readonly hold: CodeHold | null;
  readonly newAttempt: boolean;
}

export const holdOfRefusal = (refusal: Refusal): CodeHold | null => {
  switch (refusal.code) {
    case 'LOCKED':
      return { kind: 'locked', reason: 'LOCKED', seconds: refusal.retryAfterSeconds };
    case 'RESEND_TOO_SOON':
    case 'TOO_MANY_SENDS':
      return { kind: 'wait', reason: refusal.code, seconds: refusal.retryAfterSeconds };
    default:
      return null;
  }
};

export const codeEffectOf = (error: unknown): CodeEffect => {
  const refusal = toRefusal(error);
  return { hold: holdOfRefusal(refusal), newAttempt: asksForNewAttempt(refusal) };
};
